import React from 'react';
import { BreadcrumbAtual, BreadcrumbLink, BreadcrumbStyled } from './breadcrumb.component.style';
// O último item é a posição atual (sem clique).
export var Breadcrumb = function (_a) {
    var items = _a.items;
    return (React.createElement(BreadcrumbStyled, { "aria-label": "Navega\u00E7\u00E3o" }, items.map(function (item, index) {
        var atual = index === items.length - 1;
        return (React.createElement(React.Fragment, { key: item.label + "-" + index },
            index > 0 && React.createElement("span", { "aria-hidden": "true" }, "\u203A"),
            atual ? (React.createElement(BreadcrumbAtual, { "aria-current": "page" }, item.label)) : (React.createElement(BreadcrumbLink, { type: "button", onClick: item.onClick }, item.label))));
    })));
};
